import { NotificationsService } from '@notifications/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkNotificationsAsReadBody } from '@core-http';

export class MarkAsReadNotificationsCommandHandler {
  private readonly notificationsService: NotificationsService = inject(NotificationsService);

  markAsRead(ids: string[]): Observable<void> {
    const payload: MarkNotificationsAsReadBody = { notificationIds: ids };

    return this.notificationsService.markAsRead(payload);
  }
}
